import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import productData from '../data/products..json';

const ProductDetail = () => {
    const { id } = useParams();
    const product = productData.products.find((p) => p.id === parseInt(id));
    const [productImage, setProductImage] = useState(product?.images.gallery[0] || '');
    const [selected, setSelected] = useState(0);
    const [isImageChanging, setIsImageChanging] = useState(false);

    const handleImageClick = (img, index) => {
        setIsImageChanging(true);
        setTimeout(() => {
            setProductImage(img);
            setSelected(index);
            setIsImageChanging(false);
        }, 150);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    if (!product) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-900">
                <div className="text-white text-2xl">Ürün bulunamadı</div>
            </div>
        );
    }

    return (
        <div
            className="min-h-screen bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: 'url("/Images/products-background.jpg")' }}
        >

            <div className="container mx-auto px-4 pt-24 pb-12">

                {/* Ana İçerik Container */}
                <div className="max-w-8xl mx-auto">

                    {/* Ürün Başlığı - Mobile */}
                    <div className="text-center mb-8 lg:hidden">
                        <h1 className="text-3xl sm:text-4xl font-bold font-montserrat text-white mb-2">
                            {product.name}
                        </h1>
                        <h3 className="text-lg text-gray-300 font-montserrat mb-2">
                            {product.category}
                        </h3>
                        <p className="text-gray-300 mb-2 px-4">
                            {product.description}
                        </p>
                        <h3 className="text-xl text-white font-montserrat">
                            3 Yıl Garantili
                        </h3>
                    </div>

                    {/* Ana Layout */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">

                        {/* Sol Taraf - Resim Galerisi */}
                        <div className="space-y-6 lg:pt-32">
                            {/* Ana Resim */}
                            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl p-6 shadow-xl">
                                <div className="flex justify-center items-center">
                                    <img
                                        src={productImage}
                                        alt={product.name}
                                        className={`w-full max-w-md h-64 sm:h-80 md:h-96 object-contain transition-opacity duration-300 ${isImageChanging ? 'opacity-0' : 'opacity-100'
                                            }`}
                                    />
                                </div>
                            </div>

                            {/* Küçük Resimler */}
                            <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
                                {product.images.gallery.map((img, index) => (
                                    <div
                                        key={index}
                                        className={`p-2 rounded-lg backdrop-blur-lg border-2 cursor-pointer transition-all duration-300 hover:bg-white/10 ${selected === index
                                            ? 'bg-white/20 border-white/40'
                                            : 'border-white/20'
                                            }`}
                                        onClick={() => handleImageClick(img, index)}
                                    >
                                        <img
                                            src={img}
                                            alt={`${product.name} ${index + 1}`}
                                            className="h-12 w-12 sm:h-16 sm:w-16 object-contain"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Sağ Taraf - Ürün Bilgileri */}
                        <div className="space-y-8">

                            {/* Ürün Başlığı - Desktop */}
                            <div className="hidden lg:block text-center">
                                <h1 className="text-4xl xl:text-5xl font-bold font-montserrat text-white mb-3">
                                    {product.name}
                                </h1>
                                <h3 className="text-xl text-gray-300 font-montserrat mb-3">
                                    {product.category}
                                </h3>
                                <p className="text-gray-300 mb-4 text-lg leading-relaxed">
                                    {product.description}
                                </p>
                                <h3 className="text-xl text-white font-montserrat">
                                    3 Yıl Garantili
                                </h3>
                            </div>

                            {/* Özellikler Grid */}
                            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">

                                {/* İşlemci */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">İşlemci</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Marka:</span>
                                            <span className="font-semibold text-right">{product.specs.processor.brand}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Model:</span>
                                            <span className="font-semibold text-right">{product.specs.processor.model}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Çekirdek:</span>
                                            <span className="font-semibold">{product.specs.processor.cores}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Thread:</span>
                                            <span className="font-semibold">{product.specs.processor.threads}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Grafik Kartı */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">Grafik Kartı</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Marka:</span>
                                            <span className="font-semibold text-right">{product.specs.graphics.brand}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Model:</span>
                                            <span className="font-semibold text-right">{product.specs.graphics.model}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Hafıza:</span>
                                            <span className="font-semibold">{product.specs.graphics.memory}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Işın İzleme:</span>
                                            <span className="font-semibold">{product.specs.graphics.rayTracing ? "Var" : "Yok"}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Hafıza */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">Hafıza</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Tür:</span>
                                            <span className="font-semibold">{product.specs.memory.type}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Kapasite:</span>
                                            <span className="font-semibold">{product.specs.memory.capacity}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Hız:</span>
                                            <span className="font-semibold">{product.specs.memory.speed}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Slot:</span>
                                            <span className="font-semibold">{product.specs.memory.slots}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Depolama */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">Depolama</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Tür:</span>
                                            <span className="font-semibold">{product.specs.storage.primary.type}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Kapasite:</span>
                                            <span className="font-semibold">{product.specs.storage.primary.capacity}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Marka:</span>
                                            <span className="font-semibold text-right">{product.specs.storage.primary.brand}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Anakart */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">Anakart</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Chipset:</span>
                                            <span className="font-semibold text-right">{product.specs.motherboard.chipset}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Form Faktörü:</span>
                                            <span className="font-semibold text-right">{product.specs.motherboard.formFactor}</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Güç Kaynağı */}
                                <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-xl p-4 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300">
                                    <h3 className="text-lg font-bold mb-3 text-[#f1f0ea] uppercase tracking-wide">Güç Kaynağı</h3>
                                    <div className="space-y-2 text-sm">
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Güç:</span>
                                            <span className="font-semibold">{product.specs.powerSupply.wattage}</span>
                                        </div>
                                        <div className="flex justify-between py-1 border-b border-white/10">
                                            <span className="text-gray-300">Verimlilik:</span>
                                            <span className="font-semibold">{product.specs.powerSupply.efficiency}</span>
                                        </div>
                                        <div className="flex justify-between py-1">
                                            <span className="text-gray-300">Modüler:</span>
                                            <span className="font-semibold">{product.specs.powerSupply.modular ? "Evet" : "Hayır"}</span>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetail;